module.exports = __webpack_public_path__ + "img/271-eaf66f.png";